/** Base URL for images shipped under `src/assets/imagebucket`. */
export const IMAGE_BUCKET_BASE = '/assets/imagebucket';

/**
 * Bundled files in `src/assets/imagebucket`. Keep in sync when adding/removing files.
 * Paths are exposed as app URLs (e.g. `/assets/imagebucket/ardu.JPG`).
 */
export const IMAGE_BUCKET_FILES = [
  'ardu.JPG',
  'devpit.JPG',
  'devpit1.JPG',
  'kb.JPG',
  'profile.JPG',
  'watermark.png'
] as const;

export interface ImagebucketOption {
  file: string;
  url: string;
  label: string;
}

function labelFromFile(file: string): string {
  const base = file.replace(/\.[^.]+$/, '');
  const spaced = base.replace(/([a-z])([A-Z0-9])/g, '$1 $2').replace(/(\d+)/g, ' $1');
  return spaced
    .trim()
    .split(/[\s_\-]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}

export const IMAGE_BUCKET_OPTIONS: readonly ImagebucketOption[] = IMAGE_BUCKET_FILES.map((file) => ({
  file,
  url: `${IMAGE_BUCKET_BASE}/${file}`,
  label: labelFromFile(file)
}));
